module.exports = __webpack_public_path__ + "static/media/system_error.2c4f5a2d.mp3";